"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UnstyledInput = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _warning = _interopRequireDefault(require("warning"));

var _excluded = ["classes", "className", "primary", "secondary", "label", "error", "errorMessage"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    wrapper: {
      position: 'relative'
    },
    root: {
      width: '100%',
      border: "1px solid ".concat(theme.palette.grey.light),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.grey.medium),
        backgroundColor: 'rgba(200, 200, 200, 0.1)'
      }
    },
    label: {
      display: 'block'
    },
    input: {
      padding: '0.5rem'
    },
    textarea: {
      padding: '1.5rem'
    },
    primary: _objectSpread({}, theme.typography.form1),
    secondary: _objectSpread({}, theme.typography.form2),
    error: {
      marginTop: -1,
      padding: '0.5rem',
      width: '100%',
      backgroundColor: '#f04124',
      color: 'white',
      fontSize: '.75rem',
      letterSpacing: '0.48px',
      lineHeight: '18px',
      fontStyle: 'italic',
      fontWeight: 400
    }
  };
};

var UnstyledInput = function UnstyledInput(props) {
  var _clsx;

  var classes = props.classes,
      className = props.className,
      primary = props.primary,
      secondary = props.secondary,
      label = props.label,
      error = props.error,
      errorMessage = props.errorMessage,
      rest = _objectWithoutProperties(props, _excluded);

  (0, _warning["default"])(!(primary && secondary), 'Input cannot be Primary and Secondary Simultaneously');
  var Component = props.component;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx2["default"])(className, classes.wrapper)
  }, label ? /*#__PURE__*/_react["default"].createElement("label", {
    className: classes.label
  }, label) : null, /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: (0, _clsx2["default"])(classes.root, classes[Component], (_clsx = {}, _defineProperty(_clsx, classes.primary, primary), _defineProperty(_clsx, classes.secondary, secondary), _clsx))
  }, rest)), error ? /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.error
  }, errorMessage) : null);
};

exports.UnstyledInput = UnstyledInput;
UnstyledInput.defaultProps = {
  classes: {},
  onChange: function onChange() {},
  value: '',
  component: 'input'
};
UnstyledInput.propTypes = {
  classes: _propTypes["default"].any,
  className: _propTypes["default"].string,
  primary: _propTypes["default"].bool,
  secondary: _propTypes["default"].bool,
  component: _propTypes["default"].oneOf(['input', 'textarea']),
  label: _propTypes["default"].string,
  error: _propTypes["default"].error,
  errorMessage: _propTypes["default"].string
};

var _default = (0, _reactJss["default"])(styles)(UnstyledInput);

exports["default"] = _default;